import { useRouter } from "next/router";
import { useMemo } from "react";
import { Icon, ImageLite, PageLink, Paragraph } from "shared/components";
import { formatDate } from "shared/utils";

import styles from "./Item.module.scss";

export const Item = ({ title, slug, date, previewImage }) => {
  const { locale } = useRouter();
  const itemDate = useMemo(() => date, [date]);

  const articleDate = useMemo(() => {
    return formatDate(itemDate, locale);
  }, [locale, itemDate]);

  return (
    <PageLink directory={"news"} slug={slug} className={styles.wrapper}>
      <div className={styles.content}>
        <ImageLite image={previewImage} className={styles.image} />
        <span className={styles.arrow}>
          <Icon className={styles.icon} name="arrow_right" />
        </span>
        <Paragraph className={styles.date} color="grey" uppercase>
          {articleDate}
        </Paragraph>
        <Paragraph className={styles.title} color="dark">
          {title}
        </Paragraph>
      </div>
    </PageLink>
  );
};
